import { type } from "@testing-library/user-event/dist/type";
import {
  EDIT_USER_SUBMIT,
  API_FETCH_MENU,
  API_FETCH_MENU_SUCCESS,
  API_FETCH_MENU_ITEM,
  API_FETCH_MENU_iTEM_ERROR,
  API_FETCH_MENU_iTEM_SUCCESS,
  ADD_MENU_ITEM,
  ADD_ITEM_MENU_SUCCESS,
  REMOVE_ITEM_MENU,
  REMOVE_ITEM_MENU_SUCCESS,
  GENERATE_LOGIN_OTP_SUCCESS,
  SEND_LOGIN_OTP_SUCCESS,
  SEND_LOGIN_SUCCESS,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  RESET_PASSWORD,
  API_FETCH_USER_SUCCESS,
  API_FETCH_USER,
  UPDATE_ITEM_STATUS_MENU,
  UPDATE_STATUS_API,
  UPDATE_STATUS_API_SUCCESS,
  UPDATE_ITEM_MENU,
  UPDATE_ITEM_MENU_SUCCESS,
  ADD_USER,
  ADD_USER_SUCCESS,
  ADD_CATEGORY,
  ADD_CATEGORY_SUCCESS,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_CATEGORY,
  EDIT_CATEGORY_SUBMIT,
  EDIT_CATEGORY_SUCCESS,
  UPDATE_USER,
  UPDATE_CATEGORY,
  SEND_LOGIN,
  SEND_LOGOUT,
  FETCH_USERS,
  FETCH_CATEGORIES,
  EDIT_MENU_ITEM,
  UPDATE_MENU_ITEM,
  EDIT_MENU_ITEM_SUBMIT,
  EDIT_MENU_ITEM_SUCCESS,
  CLEAR_CART_FOR_TABLE,
  ADD_ITEM_TO_CART,
  REMOVE_ITEM_TO_CART, 
  FETCH_LIVE_ORDERS_BY_TABLEOTP, 
  FETCH_LIVE_ORDERS,
  FETCH_LIVE_ORDER_SUCCESS,
  FETCH_LIVE_ORDER_FAILURE,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAILURE,
  FETCH_ORDER_HISTORY_BY_TABLEOTP,
  FETCH_ORDER_HISTORY,
  FETCH_ORDER_HISTORY_SUCCESS,
  FETCH_ORDER_HISTORY_FAILURE,
  FETCH_CANCEL_ORDER,
  FETCH_CANCEL_ORDER_SUCCESS,
  FETCH_CANCEL_ORDER_FAILURE,
  ADD_TABLE_NUMBER,
  ADD_TABLE_NUMBER_SUCCESS,
  ADD_TABLE_NUMBER_FAILURE,
  FETCH_TABLES,
  FETCH_TABLES_SUCCESS,
  FETCH_TABLES_FAILURE,
  DELETE_TABLE,
  DELETE_TABLE_SUCCESS,
  DELETE_TABLE_FAILURE,
  EDIT_TABLE,
  EDIT_TABLE_SUCCESS,
  EDIT_TABLE_FAILURE,
  FETCH_RESTAURANT_DETAIL_REQUEST, 
  FETCH_RESTAURANT_DETAIL_SUCCESS, 
  FETCH_RESTAURANT_DETAIL_FAILURE,
  UPDATE_RESTAURANT_PROFILE_REQUEST, 
  UPDATE_RESTAURANT_PROFILE_SUCCESS, 
  UPDATE_RESTAURANT_PROFILE_FAILURE,
  FETCH_TAX_REQUEST, 
  FETCH_TAX_SUCCESS, 
  FETCH_TAX_FAILURE, 
  UPDATE_TAX_REQUEST, 
  UPDATE_TAX_SUCCESS, 
  UPDATE_TAX_FAILURE,
  FETCH_TABLES_WITH_OTP,
  UPDATE_TABLE_STATUS_REQUEST,
  UPDATE_TABLE_STATUS_SUCCESS,
  UPDATE_TABLE_STATUS_FAILURE,
  PLACE_ORDER_FOR_TABLE,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  FETCH_BILL_REQUEST,
  FETCH_BILL_SUCCESS,
  SAVE_BILL_REQUEST,
  RESET_SAVED_BILL,
  FETCH_BILLS,
  FETCH_BILLS_SUCCESS,
  FETCH_BILLS_FAILURE,
  FETCH_BILL_ITEM,
  FETCH_BILL_ITEM_SUCCESS,
  FETCH_BILL_ITEM_FAILURE,
  CLEAR_CART,
  LOAD_CART_FROM_BILL,
  GET_RESERVATIONS_REQUEST,
  GET_RESERVATIONS_SUCCESS,
  GET_RESERVATIONS_FAILURE,
  CREATE_RESERVATION_REQUEST,
  CREATE_RESERVATION_SUCCESS,
  UPDATE_RESERVATION_REQUEST,
  UPDATE_RESERVATION_SUCCESS,
  FETCH_DASHBOARD,
  FETCH_DASHBOARD_SUCCESS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  FETCH_SERVICE_REQUEST,
  FETCH_SERVICE_REQUEST_SUCCESS,
  UPDATE_SERVICE_REQUEST,
  UPDATE_SERVICE_REQUEST_SUCCESS,
  OPEN_GLOBAL_POPUP,
  CLOSE_GLOBAL_POPUP,
  ADD_NOTE,
  ADD_BANNER,
  EDIT_BANNER,
  EDIT_BANNER_SUCCESS,
  API_FETCH_BANNER,
  API_FETCH_BANNER_SUCCESS,
  ADD_BANNER_SUCCESS,
  DELETE_BANNER,
  DELETE_BANNER_SUCCESS,
  UPDATE_BANNER_STATUS,
  UPDATE_BANNER_STATUS_SUCCESS,
  UPDATE_BANNER,
  UPDATE_BANNER_SUCCESS,
  FETCH_GALLERY_IMAGE,
  FETCH_CATEGORY_ADDON_MAPPINGS,
  SAVE_CATEGORY_ADDON_MAPPINGS,
  CLEAR_CATEGORY_ADDON_MAPPINGS,
  FETCH_MENU_ITEM_ADDON_MAPPINGS,
  SAVE_MENU_ITEM_ADDON_OVERRIDE,
  CLEAR_MENU_ITEM_ADDON_MAPPINGS,
} from "./constant";

export const fetchMenuItemAddonMappings = (menuId) => ({
  type: FETCH_MENU_ITEM_ADDON_MAPPINGS,
  payload: menuId,
});

export const saveMenuItemAddonOverride = (payload) => ({
  type: SAVE_MENU_ITEM_ADDON_OVERRIDE,
  payload, // { menuId, addonGroupId, isExcluded }
});

export const clearMenuItemAddonMappings = () => ({
  type: CLEAR_MENU_ITEM_ADDON_MAPPINGS,
});

export const fetchCategoryAddonMappings = (categoryId) => ({
  type: FETCH_CATEGORY_ADDON_MAPPINGS,
  payload: categoryId,
});

export const saveCategoryAddonMappings = (payload) => ({
  type: SAVE_CATEGORY_ADDON_MAPPINGS,
  payload, // { categoryId, addonGroupIds }
});

export const clearCategoryAddonMappings = () => ({
  type: CLEAR_CATEGORY_ADDON_MAPPINGS,
});

export const apiCallRequest = () => ({
  type: 'API_CALL_REQUEST'
});

export const apiCallSuccess = (data) => ({
  type: 'API_CALL_SUCCESS',
  payload: data
});

export const apiCallFailure = (error) => ({
  type: 'API_CALL_FAILURE',
  payload: error
});

export const changePassword = (data)=> ({
  type: CHANGE_PASSWORD,
  payload: data
});

export const changePasswordSuccess = (data)=> ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: data
});

export const fetchReservation = (data) => ({
  type: GET_RESERVATIONS_REQUEST,
  payload: data
});

export const fetchReservationSuccess = (data) => ({
  type: GET_RESERVATIONS_SUCCESS,
  payload: data
});

export const fetchReservationFailure = (error) => ({
  type: GET_RESERVATIONS_FAILURE,
  payload: error
});

export const saveReservation = (data) => ({
   type: CREATE_RESERVATION_REQUEST, 
   payload: data
});

export const saveReservationSuccess = (data) => ({
   type: CREATE_RESERVATION_SUCCESS, 
   payload: data
});

export const UpdateReservation = (data) => ({
  type: UPDATE_RESERVATION_REQUEST,
  payload: data
});

export const editReservationSuccess = (data) => ({
  type: UPDATE_RESERVATION_SUCCESS,
  payload: data
});

export const clearCart = () => ({
  type: CLEAR_CART,
});

export const loadCartFromBill =(data) => ({
  type: LOAD_CART_FROM_BILL,
  payload: data
});

export const fetchBill = (data) => ({
  type: FETCH_BILL_REQUEST,
  payload: data
});

export const fetchBillSuccess = (data) => ({
  type: FETCH_BILL_SUCCESS,
  payload: data
});

export const saveBill = (bill, billItems, billingType = 0, tableOtp, payments = [], actionReason = null) => ({
     type: SAVE_BILL_REQUEST,
     payload: { bill, billItems, billingType, tableOtp, payments, actionReason}
  });

export const resetSavedBill = () => ({
  type: RESET_SAVED_BILL
});

export const fetchBills = (data) => ({
  type: FETCH_BILLS,
  payload: data
});

export const fetchBillsSuccess = (data) => ({
  type: FETCH_BILLS_SUCCESS,
  payload: data
});

export const fetchBillItems = (data) => ({
  type: FETCH_BILL_ITEM,
  payload: data
});

export const fetchBillItemSuccess = (data) => ({
  type: FETCH_BILL_ITEM_SUCCESS,
  payload: data
});

export const fetchBillItemFailure = (error) => ({ 
  type: FETCH_BILL_ITEM_FAILURE, 
  payload: error, 
});

export const placeOrder = (data , tableName = 0) => ({
  type: PLACE_ORDER_FOR_TABLE,
  payload: {data, tableName}
});

export const placeOrderSuccess = (user) => ({
  type: PLACE_ORDER_SUCCESS,
  payload: user
});

export const placeOrderFailure = (error) => ({ 
  type: PLACE_ORDER_FAILURE, 
  payload: error, 
});

// SAGA
export const fetchUsers = (data) => ({
  type: API_FETCH_USER,
  payload: data
});

export const fetchUsersSuccess = (data) => ({
  type: API_FETCH_USER_SUCCESS,
  payload: data
});

// SAGA
export const fetchMenuData = (data) => ({
  type: API_FETCH_MENU,
  payload: data
});

export const fetchMenuDataSuccess = (data) => ({
  type: API_FETCH_MENU_SUCCESS,
  payload: data
});

export const fetchMenuItem = (data) => ({
  type: API_FETCH_MENU_ITEM,
  payload: data
});

export const fetchMenuItemsSuccess = (data) => ({
  type: API_FETCH_MENU_iTEM_SUCCESS,
  payload: data
});

export const fetchMenuItemsError = (data) => ({
  type: API_FETCH_MENU_iTEM_ERROR,
  payload: data
});

export const addCategory = (data) => ({
  type: ADD_CATEGORY,
  payload: data
});

export const addCategorySuccess = (data) => ({
  type: ADD_CATEGORY_SUCCESS,
  payload: data
});

export const editCategory = (data) => ({
  type: EDIT_CATEGORY,
  payload: data
});

export const updateCategory = (data) => ({
  type: UPDATE_CATEGORY,
  payload: data
});

export const editCategorySubmit = (data) => ({
  type: EDIT_CATEGORY_SUBMIT,
  payload: data
});

export const editCategorySuccess = (data) => ({
  type: EDIT_CATEGORY_SUCCESS,
  payload: data
});

export const fetchCategoryList = (data) => ({
  type: FETCH_CATEGORIES,
  payload: data
});

export const deleteCategory = (data) => ({
  type: DELETE_CATEGORY,
  payload: data
});

export const deleteCategorySuccess = (data) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: data
});

export const addUser = (data) => ({
  type: ADD_USER,
  payload: data
});

export const addUserSuccess = (data) => ({
  type: ADD_USER_SUCCESS,
  payload: data
});

export const deleteUser = (data) => ({
  type: DELETE_USER,
  payload: data
});

export const deleteUserSuccess = (data) => ({
  type: DELETE_USER_SUCCESS,
  payload: data
});

export const editUser = (data) => ({
  type: EDIT_USER,
  payload: data
});

export const editUserSubmit = (data) => ({
  type: EDIT_USER_SUBMIT,
  payload: data
});

export const editUserSuccess = (data) => ({
  type: EDIT_USER_SUCCESS,
  payload: data
});

export const updateUsers = (data) => ({
  type: UPDATE_USER,
  payload: data
});

export const addItem = (data) => ({
  type: ADD_MENU_ITEM,
  payload: data
});

export const addNote = (data) => ({
  type: ADD_NOTE,
  payload: data
});

export const loginOTPsuccess = (data) => ({
  type: SEND_LOGIN_OTP_SUCCESS,
  payload: data
});

export const login = (user) => ({
  type: SEND_LOGIN,
  payload: user
});

export const logout = (user) => ({
  type: SEND_LOGOUT,
  payload: user
});

export const loginSuccess = (data) => ({
  type: SEND_LOGIN_SUCCESS,
  payload: data
});

export const loginError = (error) => ({
  type: LOGIN_ERROR,
  payload: error
});

export const cleanLoginError = (error) => ({
  type: CLEAR_LOGIN_ERROR,
  payload: ""
});

export const resetPassword = (payload) => ({
  type: RESET_PASSWORD,
  payload
});

export const generateOTPSuccess = (users) => ({
  type: GENERATE_LOGIN_OTP_SUCCESS,
  payload: users
});

export const addItemSuccess = (data) => ({
  type: ADD_ITEM_MENU_SUCCESS,
  payload: data
});
export const removeItem = (data) => ({
  type: REMOVE_ITEM_MENU,
  payload: data
});

export const removeItemSuccess = (data) => ({
  type: REMOVE_ITEM_MENU_SUCCESS,
  payload: data
});

export const editMenuItem = (data) => ({
  type: EDIT_MENU_ITEM,
  payload: data
});

export const updateMenuItem = (data) => ({
  type: UPDATE_MENU_ITEM,
  payload: data
});

export const editMenuItemSubmit = (data) => ({
  type: EDIT_MENU_ITEM_SUBMIT,
  payload: data
});

export const editMenuItemSuccess = (data) => ({
  type: EDIT_MENU_ITEM_SUCCESS,
  payload: data
});

export const updateItemStatus = (data) => ({
  type: UPDATE_ITEM_STATUS_MENU,
  payload: data
});

export const updateStatusAPI = (data) => ({
  type: UPDATE_STATUS_API,
  payload: data
});
export const updateStatusAPISuccess = (data) => ({
  type: UPDATE_STATUS_API_SUCCESS,
  payload: data
});

export const updateItem = (data) => ({
  type: UPDATE_MENU_ITEM,
  payload: data
});

export const updateItemSuccess = (data) => ({
  type: UPDATE_ITEM_MENU_SUCCESS,
  payload: data
});

export const fetchUserList = (data) => ({
  type: FETCH_USERS,
  payload: data
});

export const clearCartForTable = (tableName) => ({
    type: CLEAR_CART_FOR_TABLE,
    payload: { tableName }
});

export const addItemToCart  = (data)=> ({
  type: ADD_ITEM_TO_CART,
  payload: data
});


export const removeItemToCart = (data)=> ({
  type: REMOVE_ITEM_TO_CART,  
  payload: data
}); 

export const fetchLiveOrder = () => ({ 
  type: FETCH_LIVE_ORDERS
});

export const fetchLiveOrderByTableOtp = (data) => ({ 
  type: FETCH_LIVE_ORDERS_BY_TABLEOTP,
  payload: data 
});

export const fetchLiveOrderSuccess = (data) => ({ 
  type: FETCH_LIVE_ORDER_SUCCESS,
  payload: data 
});

export const fetchLiveOrderFailure = (error) => ({ 
  type: FETCH_LIVE_ORDER_FAILURE, 
  payload: error
 });

 export const fetctOrderHistory = () => ({ 
  type: FETCH_ORDER_HISTORY
});

export const fetctOrderHistoryByTableOtp = (data) => ({ 
  type: FETCH_ORDER_HISTORY_BY_TABLEOTP,
  payload: data 
});

export const fetchOrderHistorySuccess = (data) => ({ 
  type: FETCH_ORDER_HISTORY_SUCCESS,
  payload: data 
});

export const fetchOrderHistoryFailure = (error) => ({ 
  type: FETCH_ORDER_HISTORY_FAILURE, 
  payload: error
 });

  export const fetctCancelledOrder = () => ({ 
  type: FETCH_CANCEL_ORDER
});

export const fetchCancelledOrderSuccess = (data) => ({ 
  type: FETCH_CANCEL_ORDER_SUCCESS,
  payload: data 
});

export const fetchCancelledOrderFailure = (error) => ({ 
  type: FETCH_CANCEL_ORDER_FAILURE, 
  payload: error
});

export const updateOrderStatus = (data) => ({ 
  type: UPDATE_ORDER_STATUS,
  payload: data
}); 

export const updateOrderStatusSuccess = (data) => ({ 
  type: UPDATE_ORDER_STATUS_SUCCESS, 
  payload: data
}); 

export const updateOrderStatusFailure = (error) => ({ 
  type: UPDATE_ORDER_STATUS_FAILURE, 
  payload: error 
});

export const updateTableStatus = (data) => ({ 
  type: UPDATE_TABLE_STATUS_REQUEST,
  payload: data
}); 

export const updateTableStatusSuccess = (data) => ({ 
  type: UPDATE_TABLE_STATUS_SUCCESS,
  payload: data
});

export const updateTableStatusFailure = (error) => ({ 
  type: UPDATE_TABLE_STATUS_FAILURE,
  payload: error
});

export const addTableNumber = (number,capacity, start, end) => ({ 
  type: ADD_TABLE_NUMBER, 
  payload: { tableNumber: number, capacity:capacity, startTableNumber: start, endTableNumber: end } 
}); 

export const addTableNumberSuccess = (data) => ({ 
  type: ADD_TABLE_NUMBER_SUCCESS, 
  payload: data
}); 

export const addTableNumberFailure = (error) => ({ 
  type: ADD_TABLE_NUMBER_FAILURE, 
  payload: error 
});

export const fetchDashboard = (start, end) => ({ 
  type: FETCH_DASHBOARD,
  payload: {start, end}
}); 

export const fetchDashboardSuccess = (data) =>
  ({ 
  type: FETCH_DASHBOARD_SUCCESS, 
  payload:data
}); 

export const fetchTables = () => ({ 
  type: FETCH_TABLES 
}); 

export const fetchTablesSuccess = (data) =>
  ({ 
  type: FETCH_TABLES_SUCCESS, 
  payload:data
}); 

export const fetchTablesFailure = (error) => ({ 
  type: FETCH_TABLES_FAILURE, 
  payload: error 
});

export const deleteTable = (data) => ({ 
  type: DELETE_TABLE, 
  payload: data 
});

export const deleteTableSuccess = (data) => ({ 
  type: DELETE_TABLE_SUCCESS, 
  payload: data 
});

export const deleteTableFailure = (error) => ({ 
  type: DELETE_TABLE_FAILURE, 
  payload: error 
});

export const editTable = (table) => ({ 
  type: EDIT_TABLE, 
  payload: table // { restaurantTableId, tableName, tableStatus, ... } 
}); 

export const editTableSuccess = (table) => ({
   type: EDIT_TABLE_SUCCESS, 
   payload: table 
}); 

export const editTableFailure = (error) => ({ 
  type: EDIT_TABLE_FAILURE, 
  payload: error 
});

export const fetchTablesWitOtp = () => ({ 
  type: FETCH_TABLES_WITH_OTP
});

export const getRestaurantDetailRequest = (restaurantId) => ({ 
  type: FETCH_RESTAURANT_DETAIL_REQUEST, 
  payload: restaurantId, 
}); 
export const getRestaurantDetailSuccess = (data) => ({ 
  type: FETCH_RESTAURANT_DETAIL_SUCCESS, 
  payload: data, 
}); 
export const getRestaurantDetailFailure = (error) => ({ 
  type: FETCH_RESTAURANT_DETAIL_FAILURE, 
  payload: error, 
});

export const updateRestaurantProfileRequest = (data) => ({ 
  type: UPDATE_RESTAURANT_PROFILE_REQUEST, 
  payload:data,
   // contains restaurant + client fields 
   }); 


export const updateRestaurantProfileSuccess = (data) => ({ 
  type: UPDATE_RESTAURANT_PROFILE_SUCCESS, 
  payload: data, 
}); 

export const updateRestaurantProfileFailure = (error) => ({ 
  type: UPDATE_RESTAURANT_PROFILE_FAILURE, 
  payload: error, 
});

export const fetchTaxRequest = (data) => ({ 
  type: FETCH_TAX_REQUEST, 
  payload: data, 
}); 
export const fetchTaxSuccess = (data) => ({ 
  type: FETCH_TAX_SUCCESS, 
  payload: data, 
}); 
export const fetchTaxFailure = (error) => ({ 
  type: FETCH_TAX_FAILURE, 
  payload: error, 
}); 
export const updateTaxRequest = (data) => ({ 
  type: UPDATE_TAX_REQUEST, 
  payload:data, 
}); 
export const updateTaxSuccess = (data) => ({ 
  type: UPDATE_TAX_SUCCESS, 
  payload: data, 
}); 
export const updateTaxFailure = (error) => ({ 
  type: UPDATE_TAX_FAILURE, 
  payload: error, 
});

export const fetchServiceRequest = (data) => ({ 
  type: FETCH_SERVICE_REQUEST, 
  payload: data, 
}); 

export const fetchServiceRequestSuccess = (data) => ({ 
  type: FETCH_SERVICE_REQUEST_SUCCESS, 
  payload: data, 
}); 

export const updateServiceRequest = (data) => ({ 
  type: UPDATE_SERVICE_REQUEST, 
  payload: data, 
}); 

export const updateServiceRequestSuccess = (data) => ({ 
  type: UPDATE_SERVICE_REQUEST_SUCCESS, 
  payload: data, 
}); 

export const openGlobalPopup = (popupKey) => ({
  type: OPEN_GLOBAL_POPUP,
  payload: popupKey
});

export const closeGlobalPopup = () => ({
  type: CLOSE_GLOBAL_POPUP
});

export const addBanner = (data) => ({ 
  type: ADD_BANNER, 
  payload: data, 
}); 

export const addBannerSuccess = (data) => ({ 
  type: ADD_BANNER_SUCCESS, 
  payload: data
}); 

export const editBanner = (data) => ({ 
  type: EDIT_BANNER, 
  payload: data, 
}); 

export const editBannerSuccess = (data) => ({ 
  type: EDIT_BANNER_SUCCESS, 
  payload: data
});

export const updateBanner = (data) => ({ 
  type: UPDATE_BANNER, 
  payload: data, 
}); 

export const updateBannerSuccess = (data) => ({ 
  type: UPDATE_BANNER_SUCCESS, 
  payload: data,  
}); 

export const fetchBanner = () => ({ 
  type: API_FETCH_BANNER 
}); 

export const fetchBannerSuccess = (data) =>
({ 
  type: API_FETCH_BANNER_SUCCESS, 
  payload:data
});

export const deleteBanner = (data) => ({ 
  type: DELETE_BANNER,  
  payload: data 
});

export const deleteBannerSuccess = (data) => ({ 
  type: DELETE_BANNER_SUCCESS, 
  payload: data 
});

export const updateBannerStatus = (data) => ({ 
  type: UPDATE_BANNER_STATUS,  
  payload: data 
});

export const updateBannerStatusSuccess = (data) => ({ 
  type: UPDATE_BANNER_STATUS_SUCCESS,  
  payload: data 
});

export const fetchGalleryImage = (data) => ({ 
  type: FETCH_GALLERY_IMAGE,  
  payload: data 
});
